import imageIcon from '../../../../assets/images/elementTag-removebg-preview.png'


export const skills: string[] = [
  'Html',
  'Css',
  'JavaScript',
  'TypeScript',
  'NextJs',
  'Ionic',
  'React',
  'React Native',
  'Expo',
  'Jest',
  'Git',
  'Node',
  'Express',
  'MogoDB',
  'Jira',
]

export const stacks = [
  {
    id: 1,
    title: 'Frontend Development',
    icon: imageIcon,
   description: 'I design and develop scalable, reusable, performant and readable web solutions and applications using HTML5, JavaScript, TypeScript, CSS3 and frameworks like React.js. I also write unit and integrated tests using testing tools like jest.',
  },
  {
    id: 2,
    title: 'Backend Development',
    icon: imageIcon,
   description: 'I design and implement REST APIs to facilitate highly scalable web applications using SQL, Groovy on Grails, Node.js. I also write unit and integrated tests for these APIs using testing tools like mocha and spark.',
  },
  {
    id: 2,
    title: 'Mobile App Development',
    icon: imageIcon,
   description: 'I design and develop scalable, reusable, performant and readable mobile solutions and applications using Ionic and React Native. I also write unit and integrated tests using testing tools like jest.',
  },
]